module.exports = __webpack_public_path__ + "static/media/icn_corona_finity.d58c14f5.svg";